import { Component, Input, OnInit } from '@angular/core';
import { NgRedux } from '@angular-redux3/store';
import { APause, APlay, PlaylistRemoteAppState } from '../../../store';
import { Media, PlayerStatus } from '../../../store/entities';
import { SyncDialogService } from '../../../services/sync-dialog.service';

@Component({
  selector: 'mwo-play-btn',
  templateUrl: './play-btn.component.html',
  styleUrls: ['./play-btn.component.scss']
})
export class PlayBtnComponent implements OnInit {
  @Input() media: Media;
  isPlaying: boolean;
  @Input() disabled: boolean;
  private playerId: string;
  private eventId: string;

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private syncDialogService: SyncDialogService
  ) { }

  ngOnInit() {
    this.ngRedux.select<PlayerStatus>('player').subscribe(({ isPlaying, media, player }) => {
      if (player && player.id) {
        this.playerId = player.id;
      }
      if (isPlaying && media) {
        this.isPlaying = isPlaying && (!this.media || this.media.id === media.id);
      } else {
        this.isPlaying = false;
      }
    });
  }

  play() {
      this.ngRedux.dispatch(APlay());
      this.syncDialogService.openSyncDialog('PLAY');
  }

  pause() {
    this.ngRedux.dispatch(APause());
    this.syncDialogService.openSyncDialog('PAUSE');
  }
}
